<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-dialog v-model="dialogProjet" persistent max-width="600px">
        <v-card>
          <v-card-title>Projet</v-card-title>
          <v-card-text>
            <v-form ref="formProjet" v-model="valid" lazy-validation>
              <v-text-field
                v-model="ll_programme"
                label="Projet"
                prepend-icon="post_add"
                :rules="nameRules"
                required
              ></v-text-field>
      
              <v-textarea
                v-model="objectifs"
                prepend-icon="short_text"
                label="Objectifs"
                :rules="nameRules"
                required
              ></v-textarea>

              <v-container class="px-0" fluid>
                <v-checkbox v-model="choixCodeProducteur" :label="'Choix Code producteur'"></v-checkbox>
              </v-container>
              <v-container class="px-0" fluid>
                <v-checkbox v-model="choixChefDeMenage" :label="'Choix Chef de ménage'"></v-checkbox>
              </v-container>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded class="primary" text @click="closeDialog"
              >Annuler</v-btn
            >
            <v-btn rounded class="primary" text @click="updateCreateProjet"
              >Sauvegarder</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/organisation/bailleurs')"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Projets de {{ $route.params.bailleur.abbr_bailleur }}
      {{ $route.params.bailleur.ll_bailleur }}

      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/organisation/bailleurs')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>

    <v-card-text>
      <template>
        <v-btn
          color="blue-grey"
          class="ma-2 white--text"
          rounded
          @click="dialogProjet = !dialogProjet"
        >
          <v-icon left dark> mdi-plus-circle-outline </v-icon>
          Nouveau projet
        </v-btn>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Projet</th>
                <th class="text-left">Objectifs</th>
                <th class="text-left">Choix</th>
                <th class="text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filterProject(projets)" :key="index">
                <td>{{ item.ll_programme }}</td>
                <td>{{ item.objectifs }}</td>
                <td>
                  <v-chip
                    v-if="item.choixCodeProducteur"
                    class="ma-2"
                    color="secondary"
                  >
                    CP
                  </v-chip>
                  <v-chip
                    v-if="item.choixChefDeMenage"
                    class="ma-2"
                    color="primary"
                  >
                     CM
                  </v-chip>
                </td>
                <td>
                  <v-btn
                    outlined
                    x-small
                    fab
                    dark
                    class="warning mr-2"
                    @click="openDialogProjet(item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                    outlined
                    x-small
                    fab
                    dark
                    class="danger mr-2"
                    @click="deleteProjet(item)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <v-btn
                    outlined
                    x-small
                    fab
                    dark
                    class="success"
                    @click="detailsProjet(item)"
                  >
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                  <v-btn
                    @click="goToStats(item)"
                    outlined
                    x-small
                    fab
                    dark
                    class="green ml-2"
                  >
                    <v-icon>mdi-database-export-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    if (!this.$route.params.bailleur) {
      console.log("pas de paramètres", this.$route.params.bailleur);

      this.$router.go(-1);
    }
    this.getBailleurs();
    this.GetThemes();
  },
  data() {
    return {
      idProjet: null,
      ll_programme: "",
      objectifs: "",
      dialogProjet: false,
      dialogDeleteProjet: false,
      valid: true,
      choixCodeProducteur: false,
      choixChefDeMenage: false,
  
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
    };
  },
  computed: {
    ...mapState({
      bailleurs: (state) => state.Bailleurs.bailleurs,
      projets: (state) => state.Projets.projets,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
    }),
  },
  methods: {
    ...mapActions({
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetThemes: "Themes/GetAll",
    }),

    goToStats(item) {
      this.$router.push({
        path: "/organisation/StatsFormationsDeGroupe",
        query: item,
      });
    },
    filterProject(projets) {
      const idBailleur = this.$route.params.bailleur.id;
      //console.log(projets);
      return _.filter(projets, { bailleurs_id_bailleur: idBailleur });
    },
    updateCreateProjet() {
      let self = this;

      if (this.$refs.formProjet.validate()) {
        if (!this.idProjet) {
          let uuid = "0000000000000000aaaprojet-" + this.$uuid.v4();
          const newProjet = {
            ll_programme: this.ll_programme,
            objectifs: this.objectifs,
            abbr_bailleur: this.$route.params.bailleur.abbr_bailleur,
            bailleurs_id_bailleur: this.$route.params.bailleur.id,
            id_bailleur: this.$route.params.bailleur.id,
            ll_bailleur: this.$route.params.bailleur.ll_bailleur,
            created: self.$firebase.firestore.FieldValue.serverTimestamp(),
            choixCodeProducteur: this.choixCodeProducteur,
            choixChefDeMenage: this.choixChefDeMenage,
          };
          console.log("New project:", newProjet);

          // Add a new document in collection "projets"
          this.$firebase
            .firestore()
            .collection("projets")
            .doc(uuid)
            .set(newProjet)
            .then(function () {
              console.log("projet successfully written!");
              self.idProjet = null;
            })
            .catch(function (error) {
              console.error("Error writing projet: ", error);
            });
          self.idProjet = null;
        } else {
          const updatedProjet = {
            ll_programme: this.ll_programme,
            objectifs: this.objectifs,
            abbr_bailleur: this.$route.params.bailleur.abbr_bailleur,
            bailleurs_id_bailleur: this.$route.params.bailleur.id,
            id_bailleur: this.$route.params.bailleur.id,
            ll_bailleur: this.$route.params.bailleur.ll_bailleur,
            updated: self.$firebase.firestore.FieldValue.serverTimestamp(),
            choixCodeProducteur: this.choixCodeProducteur,
            choixChefDeMenage: this.choixChefDeMenage,
          };
          console.log("project id : ", self.idProjet);
          console.log("project updated : ", updatedProjet);
          var projetRef = this.$firebase
            .firestore()
            .collection("projets")
            .doc(self.idProjet);
          projetRef.set(updatedProjet, { merge: true });
        }
        self.idProjet = null;
        this.closeDialog();
        this.getProjets();
      }
    },
    openDialogProjet(projet) {
      this.idProjet = projet.id;
      this.dialogProjet = true;
      this.ll_programme = projet.ll_programme;
      this.objectifs = projet.objectifs;
      this.choixCodeProducteur = projet.choixCodeProducteur;
      this.choixChefDeMenage = projet.choixChefDeMenage;
    },
    deleteProjet(projet) {
      let self = this;
      //delete bailleur in collection bailleurs
      const index = this.projets.indexOf(projet);
      this.$confirm(
        "Voulez vous Effacer ce projet <strong style='color:red'>" +
          projet.ll_programme +
          "</strong> ?, Cela entrainera l'effacement des activités liés "
      ).then((ok) => {
        if (ok) {
          //delete projet in collection projets
          this.projets.splice(index, 1);
          this.$firebase
            .firestore()
            .collection("projets")
            .doc(projet.id)
            .delete()
            .then(function () {
              console.log("Projet successfully deleted!");
              //const index = self.bailleurs.indexOf(id_bailleur)
            })
            .catch(function (error) {
              console.error("Error removing projet: ", error);
            });
        }
      });
      this.getProjets();
    },
    closeDialog() {
      this.dialogProjet = false;
      this.dialogDeleteProjet = false;
      this.$refs.formProjet.reset();
      this.idProjet = null;
      this.choixChefDeMenage = false;
      this.choixCodeProducteur = false;

    },
    detailsProjet(projet) {
      this.$router.push({
        name: "organisation-projets-id",
        params: { projet },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
